<template>
  <div class="row text-center">
    <div class="col-12">
      <section class="new-password">
        <div class="container">
          <div class="new-password__group">
            <h1 class="new-password__title">Nova senha</h1>
            <form class="new-password__form">
              <div
                class="form-group"
                :class="{ 'form-group--error': $v.password.$error }"
              >
                <input
                  id="exampleInputPassword1"
                  v-model="$v.password.$model"
                  type="password"
                  class="form-control"
                  placeholder="Nova senha"
                />

                <div v-if="$v.password.$error" class="error">
                  <div v-if="!$v.password.required" class="error">
                    Campo obrigatório
                  </div>
                  <div v-else-if="!$v.password.minLength" class="error">
                    Deve conter no mínimo, 8 caracteres
                  </div>
                  <div
                    v-else-if="!$v.password.hasUppercaseLetter"
                    class="error"
                  >
                    {{ passwordMessages.uppercase }}
                  </div>
                  <div
                    v-else-if="!$v.password.hasLowercaseLetter"
                    class="error"
                  >
                    {{ passwordMessages.lowercase }}
                  </div>
                  <div v-else-if="!$v.password.hasNumber" class="error">
                    {{ passwordMessages.number }}
                  </div>
                  <div
                    v-else-if="!$v.password.hasSpecialCharacter"
                    class="error"
                  >
                    {{ passwordMessages.specialCharacter }}
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                :class="{
                  'form-group--error': $v.password_confirmation.$error
                }"
              >
                <input
                  id="exampleInputPassword2"
                  v-model="$v.password_confirmation.$model"
                  type="password"
                  class="form-control"
                  placeholder="Repita a senha"
                />

                <div v-if="$v.password_confirmation.$error" class="error">
                  <div v-if="!$v.password_confirmation.required" class="error">
                    Campo obrigatório
                  </div>
                  <div
                    v-else-if="!$v.password_confirmation.minLength"
                    class="error"
                  >
                    Deve conter no mínimo, 8 caracteres
                  </div>
                  <div
                    class="error"
                    v-else-if="!$v.password_confirmation.confirmation"
                  >
                    Senhas devem ser iguais
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="button3"
                @click.prevent="sendPassword()"
              >
                Alterar a senha
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { authMethods, authComputed } from "./../state/helpers";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { router } from "../router";
import {
  PASSWORD_MESSAGES,
  hasUppercaseLetter,
  hasLowercaseLetter,
  hasNumber,
  hasSpecialCharacter
} from "../utils/validations/password";

export default {
  name: "UpdatePassword",
  data() {
    return {
      password: "",
      password_confirmation: ""
    };
  },
  beforeMount() {
    if (!Object.keys(this.$route.query).length) {
      return this.$router.push("/login");
    }
  },

  validations: {
    password: {
      required,
      minLength: minLength(8),
      hasUppercaseLetter,
      hasLowercaseLetter,
      hasNumber,
      hasSpecialCharacter
    },
    password_confirmation: {
      required,
      minLength: minLength(8),
      confirmation: sameAs("password")
    }
  },

  methods: {
    ...authMethods,
    sendPassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.updatePassword({
          password: this.password,
          password_confirmation: this.password_confirmation,
          headers: this.$route.query
        }).then(() => {
          this.$router.push("/");
        });
      }
    }
  },

  computed: {
    ...authComputed,
    passwordMessages() {
      return PASSWORD_MESSAGES;
    }
  }
};
</script>
